import React from 'react';
import { Link } from 'react-router-dom';

export default class HeroOne extends React.Component {
  componentDidMount() {
    const $ = window.$;

    if ($('.slider-carousel').length) {
      $('.slider-carousel').owlCarousel({
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        loop: true,
        margin: 0,
        nav: false,
        singleItem: true,
        smartSpeed: 500,
        autoplay: true,
        autoplayTimeout: 6000,
        navText: [
          '<span class="icon-right-arrow"></span>',
          '<span class="icon-right-arrow"></span>',
        ],
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 1,
          },
          1024: {
            items: 1,
          },
        },
      });
    }
  }

  render() {
    let publicUrl = process.env.PUBLIC_URL + '/';
    return (
      <>
        <section className="slider-one-sec style3">
          <div className="slider-carousel owl-carousel owl-theme">
            {/* Start Slider One Single - Ship Machinery */}
            <div className="slider-one__single">
              <div
                className="image-layer"
                style={{
                  backgroundImage:
                    'url(' + publicUrl + 'assets/images/update1.0/banner1.jpg)',
                }}
              ></div>
              <div className="container">
                <div className="row clearfix">
                  <div className="col-xl-12">
                    <div className="slider-one__single-content">
                      <h3>Reliable Marine Solutions</h3>
                      <h2>
                        Genuine & Reconditioned <br /> Ship Machinery
                      </h2>
                      <p>
                        Supplying engines, compressors, pumps, purifiers, and
                        essential marine equipment to keep your fleet operating
                        smoothly.
                      </p>
                      <div className="btn-box">
                        <Link
                          to={process.env.PUBLIC_URL + `/`}
                          className="thm-btn"
                          data-text="Explore Machinery +"
                        >
                          Explore Machinery +
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Slider One Single */}

            {/* Start Slider One Single - Navigation & Safety */}
            <div className="slider-one__single">
              <div
                className="image-layer"
                style={{
                  backgroundImage:
                    'url(' + publicUrl + 'assets/images/update1.0/banner2.jpg)',
                }}
              ></div>
              <div className="container pl-0">
                <div className="row clearfix">
                  <div className="col-xl-12">
                    <div className="slider-one__single-content text-center">
                      <h3>Advanced Navigation & Safety</h3>
                      <h2>
                        Radar, GPS, ECDIS & <br /> Lifesaving Equipment
                      </h2>
                      <p>
                        Delivering trusted navigation systems and certified
                        safety solutions for secure and efficient marine
                        operations worldwide.
                      </p>
                      <div className="btn-box">
                        <Link
                          to={process.env.PUBLIC_URL + `/`}
                          className="thm-btn"
                          data-text="View Solutions +"
                        >
                          View Solutions +
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Slider One Single */}

            {/* Start Slider One Single - Automation */}
            <div className="slider-one__single">
              <div
                className="image-layer"
                style={{
                  backgroundImage:
                    'url(' + publicUrl + 'assets/images/update1.0/banner3.jpg)',
                }}
              ></div>
              <div className="container">
                <div className="row clearfix">
                  <div className="col-xl-12">
                    <div className="slider-one__single-content">
                      <h3>Smart Ship Automation</h3>
                      <h2>
                        Integrated Control & <br /> Monitoring Systems
                      </h2>
                      <p>
                        Enhancing safety and efficiency with automation,
                        monitoring, and alarm systems tailored for modern
                        vessels.
                      </p>
                      <div className="btn-box">
                        <Link
                          to={process.env.PUBLIC_URL + `/`}
                          className="thm-btn"
                          data-text="Discover Automation +"
                        >
                          Discover Automation +
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Slider One Single */}
          </div>
        </section>
      </>
    );
  }
}
